import { render, staticRenderFns } from "./TestResults.vue?vue&type=template&id=8a5ed5c0&scoped=true&"
import script from "./TestResults.vue?vue&type=script&lang=ts&"
export * from "./TestResults.vue?vue&type=script&lang=ts&"
import style0 from "./TestResults.vue?vue&type=style&index=0&id=8a5ed5c0&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a5ed5c0",
  null
  
)

export default component.exports